import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

// safari polyfill
if (typeof window !== "undefined" && "AbortSignal" in window) {
    AbortSignal.timeout =
        AbortSignal.timeout ||
        ((duration) => {
            try {
                const controller = new AbortController();
                setTimeout(() => controller.abort(), duration);
                return controller.signal;
            } catch (err) {
                console.error(err);
                return null;
            }
        });
}

export {};
